import {useMutation, useQueryClient} from '@tanstack/react-query'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {
    httpUpdateFreelancer,
    HttpUpdateFreelancerOptionsProfilePhotoPayload
} from '@features/settings/http/settings.http.ts'
import {PhpUser, User} from '@features/user/types.ts'
import {captureException} from '@sentry/react'
import {errorHandler} from '@utilities/helpers.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {z} from 'zod'

const ResponseShape = PhpUser.pick({profile_photo_url: true})
type ResponseShape = z.infer<typeof ResponseShape>

export const useChangeFreelancerProfilePhoto = ({userId}: {userId: number}) => {
    const queryClient = useQueryClient()

    return useMutation<ResponseShape, unknown, HttpUpdateFreelancerOptionsProfilePhotoPayload>({
        mutationFn: variables =>
            parseAxiosPromise({
                axiosPromise: httpUpdateFreelancer({
                    payload: variables,
                    urlParams: {userId}
                }),
                responseShape: ResponseShape,
                onZodError: captureException
            }),
        onError: errorHandler,
        onSuccess: async data => {
            await queryClient.cancelQueries({queryKey: [QUERY_KEYS.ME]})
            queryClient.setQueryData(
                [QUERY_KEYS.ME],
                (previousData: User): User => ({
                    ...previousData,
                    profilePhotoUrl: data.profile_photo_url
                })
            )
        }
    })
}
